import { NgIf, NgStyle } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { IconName } from '@sc/data-access-assets';
import { IconComponent } from '../icon';

@Component({
  selector: 'sc-checkbox-filter',
  styleUrls: ['./checkbox-filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, NgStyle, IconComponent],
  template: `
    <div
      [class]="getContainerClass()"
      [class.checked]="toggleValue"
      [ngStyle]="{ 'background-color': getColorLight() }"
      [class.disabled]="disabled"
      tabindex="0"
      role="switch"
      [attr.aria-checked]="toggleValue"
      [attr.aria-label]="ariaLabel"
      (click)="onToggle()"
      (keydown.enter)="onToggle()"
      (keydown.space)="onToggle()"
    >
      <span
        class="circle"
        [ngStyle]="{
          'background-color': getBackgroungColor(),
          'border-color': color
        }"
      >
        <sc-icon name="check_bis" *ngIf="toggleValue"></sc-icon>
      </span>
      <span *ngIf="icon" class="icon">
        <sc-icon [name]="icon" [specificName]="specificIcon"></sc-icon>
      </span>
      <span *ngIf="text" class="text">{{ text }}</span>
    </div>
  `,
})
export class CheckboxFilterComponent {
  @Input() toggleValue = true;
  @Input() type:
    | 'garage'
    | 'outside-pad'
    | 'warn'
    | 'success'
    | 'success-alt-1'
    | 'requested'
    | 'generalist'
    | 'specialist'
    | 'requestedAndValidated'
    | 'error'
    | 'error-alt-1'
    | 'error-alt-2'
    | 'draft' = 'garage';
  @Input() icon: IconName | null = null;
  @Input() specificIcon: string = undefined;
  @Input() text = '';
  @Input() disabled = false;
  @Input() color?: string;
  @Input('aria-label') ariaLabel: string;

  @Output() toggleEvent = new EventEmitter<boolean>();

  getContainerClass() {
    return `outside ${this.type}`;
  }

  getColorLight() {
    return `${this.color}4D`;
  }

  getBackgroungColor() {
    return this.toggleValue ? this.color : '#FFFFFF';
  }

  onToggle() {
    if (this.disabled) return;

    this.toggleValue = !this.toggleValue;
    this.toggleEvent.emit(this.toggleValue);
  }
}
